import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import Loader from '../Utility/Loader/Loader';
import CustomDatePicker from '../Utility/DatePicker/DatePicker';
import './ConfirmPopup.css';

function ConfirmButtonPopup({
  onOpen,
  onConfirm,
  message,
  secondMessage,
  toggle,
  title,
  loading,
  commentText,
  isCommentOn,
  showCheckBox,
  disabledBtn,
  showThirdMsg,
  thirdMessage,
  showDate,
  setSelectedDate,
  selectedDate,
  comment,
  showCommentHeader,
  isReferenceCode,
  code,
  handleRefrenceCode,
  isDuplicateLibrary,
  isDuplicatetemplate,
  handleDuplicateName,
  showDateError,
  isGrading,
  moduleName,
  isSpec,
  fromAccountDetails,
  isFileBin,
  requireTypedConfirm,
  onCancel,
  className,
}) {
  const [allowDelete, setAllowDelete] = useState(false);
  const [typedConfirm, setTypedConfirm] = useState('');
  const { t } = useTranslation('common');
  const { t: tPopup } = useTranslation('confirm-button-popup');

  const deleteCompletly = (e) => {
    if (showCheckBox) {
      setAllowDelete(e.target.checked);
    }
  };

  const handleDateChange = (e) => {
    setSelectedDate(e);
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      toggle();
    }
  };

  return (
    <Modal show={onOpen} backdrop="static" className={['common-custom-modal modal-medium', className].filter(Boolean).join(' ')} aria-labelledby="contained-modal-title-vcenter" onHide={toggle}>
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          <span>{title}</span>
        </Modal.Title>
        <span onClick={toggle} className="icon-close cursor-pointer" />
      </Modal.Header>
      <Modal.Body>
        {loading && <Loader />}
        {!loading && (
          <>
            <div className="modal-inner-data">
              <span>
                {message && <p className="mb-16 text-center">{t`${message}`}</p>}
                {showCheckBox ? (
                  <div className="checkbox-label">
                    <input type="checkbox" id="delConfirm" name="delConfirm" onChange={deleteCompletly} value="delete" />
                    <label htmlFor="delConfirm" className="chklabel align-items-start">
                      <p className="ml-2">{secondMessage}</p>
                    </label>
                  </div>
                ) : (
                  secondMessage &&
                  (typeof secondMessage === 'string' ? (
                    <p className="mb-16 text-center">{secondMessage}</p>
                  ) : (
                    <div className="mb-16">{secondMessage}</div>
                  ))
                )}
              </span>
              {showThirdMsg && (
                <span>
                  <p className="text-center">{thirdMessage}</p>
                </span>
              )}
              {showDate && (
                <div className="date justify-content-end px-1">
                  <div className="input-button-container">
                    <CustomDatePicker
                      dateFormat="dd-MMM-yyyy"
                      name="deliveryDate"
                      popperPlace="bottom-end"
                      placeholder={t('CONFIRMATION_POPUP.DELIVERY_DATE_LABEL')}
                      onChange={handleDateChange}
                      valueProp={selectedDate ? new Date(selectedDate) : null}
                    />
                  </div>
                  {!selectedDate && showDateError && <small className="error-message">{t('CONFIRMATION_POPUP.DELIVERY_DATE_REQUIRED')}</small>}
                </div>
              )}
              {isCommentOn && (
                <div className="common-input-control">
                  {showCommentHeader && (
                    <label>
                      <strong>{t('CONFIRMATION_POPUP.COMMENT_LABEL')}</strong>
                    </label>
                  )}
                  <input
                    className="form-control"
                    rows="3"
                    onChange={commentText}
                    value={comment}
                    placeholder={t('CONFIRMATION_POPUP.ENTER_COMMENT')}
                    maxLength="200"
                  />
                  <div className="character-counter">{comment?.length || 0}/200</div>
                </div>
              )}
              {isReferenceCode && (
                <div className="common-input-control reference-input mb-0 fixed-label">
                  <label className="mb-16">
                    <span className="font-heavy">{t('CONFIRMATION_POPUP.REFERENCE_CODE_LABEL')}</span>
                  </label>
                  <input className="form-control text-bordered" onChange={handleRefrenceCode} value={code} />
                </div>
              )}
              {isDuplicateLibrary && (
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    placeholder={isSpec ? t('CONFIRMATION_POPUP.CODE') : t('CONFIRMATION_POPUP.NAME')}
                    onChange={handleDuplicateName}
                    className="form-control"
                  />
                  <label className="f-14 asterisk-req">
                    {isGrading || isSpec ? moduleName : t('CONFIRMATION_POPUP.CUSTOM_MODULE_NAME_LABEL')} <span>*</span>
                  </label>
                </div>
              )}
              {isDuplicatetemplate && (
                <div className="input-group form-floating-label fixed-label">
                  <input
                    type="text"
                    placeholder={isSpec ? t('CONFIRMATION_POPUP.CODE') : t('CONFIRMATION_POPUP.NAME')}
                    onChange={handleDuplicateName}
                    className="form-control"
                  />
                  <label className="f-14 asterisk-req">
                    {isGrading || isSpec ? moduleName : t('CONFIRMATION_POPUP.TEMPLATE_NAME')} <span>*</span>
                  </label>
                </div>
              )}
              {isFileBin && <span>{t('CONFIRMATION_POPUP.REMOVE_FOLDER_MESSAGE')}</span>}
              {requireTypedConfirm && (
                <div className="confirm-input-btn-row">
                  <div className="confirm-input-col">
                    <label className="confirm-type-label">
                      {tPopup('TYPE')}&nbsp;
                      <span className="confirm-type-keyword">{tPopup('CONFIRM')}</span>&nbsp;
                      {tPopup('TO_CONTINUE')}
                    </label>
                    <input
                      type="text"
                      className="confirm-type-input"
                      value={typedConfirm}
                      onChange={(e) => setTypedConfirm(e.target.value)}
                      // eslint-disable-next-line jsx-a11y/no-autofocus
                      autoFocus
                    />
                  </div>
                  <div className="confirm-btn-group">
                    <button type="button" className="btn-popup-cancel" onClick={handleCancel}>
                      {t('CONFIRMATION_POPUP.CANCEL')}
                    </button>
                    <button type="button" className="btn-popup-confirm" onClick={onConfirm} disabled={typedConfirm !== 'confirm'}>
                      {t('CONFIRMATION_POPUP.CONFIRM')}
                    </button>
                  </div>
                </div>
              )}
            </div>
            {fromAccountDetails && (
              <div className="common-model-footer">
                <button onClick={toggle} className="btn btn-default" type="button">
                  {t('CONFIRMATION_POPUP.OK')}
                </button>
              </div>
            )}
            {!fromAccountDetails && !requireTypedConfirm && (
              <div className="common-model-footer">
                <button onClick={onConfirm} type="button" className="btn p-0" disabled={(showCheckBox && !allowDelete) || disabledBtn}>
                  <span className="icon-Tick-1 f-24" />
                </button>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmButtonPopup;
